import type { Static } from "runtypes";
import { Array, Boolean, Dictionary, Number, Record, String, Union } from "runtypes";
import { TickerStatus } from "./TickerStatus";
import { TickerType } from "./TickerType";
import { OldScore } from "./OldScore";
import { ScoreType } from "./ScoreType";
import { IndicatorType } from "./IndicatorType";
import { FormattedExtractedInfo } from "./FormattedExtractedInfo";
import { FinancialFundamentalsType } from "./FinancialFundamentalsType";
import { Score } from "./Score";
import { CreditCosts } from "./CreditCosts";

export const DealFinderTicker = Record({
  id: String,
  symbol: String,
  name: String,
  exchange: String,
  status: TickerStatus,
  type: TickerType.nullable(),
  pricingTier: String.nullable(),
  creditCosts: CreditCosts.nullable().optional(),
  companyUrl: String.nullable(),
  companyLogoUrl: String.nullable(),
  companyBannerUrl: String.nullable(),
  companyTaxId: String.nullable(),
  companyLegalName: String.nullable(),
  projectId: String.nullable(),
  projectCreationDate: String.nullable(), // Date as string
  companyOverview: String.nullable(),
  companyDescription: String.nullable(),
  companyShortDescription: String.nullable(),
  investmentPotential: String.nullable(),
  investmentScoreAnalytical: Number.nullable(),
  investmentScoreSentiment: Number.nullable(),
  country: String.nullable(),
  stateOrProvince: String.nullable(),
  city: String.nullable(),
  yearFounded: Number.nullable(),
  industries: Array(String),
  revenue: Union(Number, String).nullable().optional(),
  investmentRating: Number.nullable(),
  hasUserWatched: Boolean,
  hasUserLiked: Boolean,
  hasUserPurchased: Boolean,
  likeCount: Number,
  indicators: Dictionary(OldScore, IndicatorType),
  scores: Union(Dictionary(OldScore, ScoreType), Array(Score)),
  financialFundamentals: Dictionary(FormattedExtractedInfo, FinancialFundamentalsType),
});

export type DealFinderTicker = Static<typeof DealFinderTicker>;
